namespace Gordic.Epk.WebControls.Vyrizeni {

    export interface IDuvodVyrizeniDto {
        /** připomínky */
        duvod_vyrizeni: string,
        /** funkční místo - předání */
        ixs_fun?: string,
        /** spisový uzel - přidělení + funkční místo  */
        ixs_su?: string
    }

    //#region *** DŮVOD VYŘÍZENÍ ***

    /** třída dialog důvodu vyřízení */
    export class DuvodVyrizeni {

        private gcontent: GContentType<GEpkDbParamsNew>;
        private form: JQuery<HTMLElement>;
        private duvodVyrizeniFormName: string = "duvod_vyrizeni";
        /** deffered, který se vyhodnotí při zavření dialogu a vrátí v thenu důvod(text) nebo se ve failu zavře */
        private dfd: JQuery.Deferred<IDuvodVyrizeniDto, IGReasonResponse>;

        private zpusobVyrizeni: Gordic.Wfl.Interface.GWflczpvEnum;
        private typPozadavku: Gordic.Wfl.Interface.TypPozadavkuEpk;
        private stateBezPripominek = false;

        /**
         * otevření důvodu vyřízení
         */
        public run(cnt: any, zpusobVyrizeni: Gordic.Wfl.Interface.GWflczpvEnum, typPozadavku: Gordic.Wfl.Interface.TypPozadavkuEpk, initialValue?: string  | null) {

            var gcontent: GContentType<GEpkDbParamsNew> = cnt;
            this.gcontent = gcontent;

            this.dfd = $.Deferred();
            this.zpusobVyrizeni = zpusobVyrizeni;
            this.typPozadavku = typPozadavku;
            this.init();

            // -- vyhodnoceni velikosti okna --

            var width = 730;
            var height = 300;

            if (this.gcontent.globalSettings != null) {
                var mobile = this.gcontent.globalSettings.get("Global.Epk.AppSettings.CardGrid");
                if (mobile === true) {
                    width = window.innerWidth - 50;
                    height = window.innerHeight - 50;
                }
            }

            // ---------------------------------

            const form = this.createForm(initialValue);

            //todo: doplnit id nebo customclass kvůli epk testům

            this.gcontent.dialogs.showModalWindow(form, {
                customClass: "reasonOfSettlementClass",
                id: "reasonOfSettlementID"
            }, {
                width: width,
                height: height,
                title: "jres:32000678",                             //RC 32000678 : Zadání připomínek
                commandBar: this.createCommandbar()
            });

            return this.dfd.promise();
        }

        private init() {
            this.stateBezPripominek = true;
            //if (this.zpusobVyrizeni === Gordic.Wfl.Interface.GWflczpvEnum.Povoleno) {
            //    this.stateBezPripominek = true;
            //}
            //else if (this.zpusobVyrizeni === Gordic.Wfl.Interface.GWflczpvEnum.VracenoKPrepracovani && (this.typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.Predani || this.typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.Prideleni)) {
            //    this.stateBezPripominek = true;
            //}
        }

        private createForm(initialValue?: string | null) {
            this.form = $("<div>");
            var Form = new Gordic.Forms.Form({
                name: "FormDuvodVyrizeniDlg",
            });
            var caption = "jres:32000677"; //RC 32000677 : Připomínky
            Form
                .addSection()
                .addRow(caption)
                 // thazmuka (26.1.2022) - přidáno počítadlo na počet znaků v připomínce
                .addField("gstringbox", Gordic.Prefabs.Field.charCounter(254), {
                    initialValue: initialValue,
                    placeholder: this.stateBezPripominek === true ? "jres:32000682" : "", //RC 32000682 : Bez připomínek
                    validators: [
                        new Gordic.Validators.Required(),
                        new Gordic.Validators.Length({ min: 1, max: 254, message: "jres:32000271" })
                    ], //RC 32000271 : Pole nesmí být prázdné a může obsahovat max. 254 znaků.
                    name: this.duvodVyrizeniFormName,
                    rows: 4
                })

            if (this.zpusobVyrizeni === Gordic.Wfl.Interface.GWflczpvEnum.VracenoKPrepracovani) {
                if (this.typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.Predani) {

                    var serverFilters: any = {};
                    serverFilters["aktivita"] = [100];

                    if (this.gcontent.row != null && this.gcontent.row.ixs_su != null)
                        serverFilters["ixs_su"] = [this.gcontent.row.ixs_su];

                    Form
                        .addSection("jres:32000693") //RC 32000693 : Změna cíle redistribuce
                        .addRow("jres:32000694") //RC 32000694 : Funkční místo
                        .addField("gselectbox",
                            Gordic.Gin.Fields.ginsfunSSU(
                                {
                                    name: "funField",
                                    //model: "IxsFun = ixs_fun",
                                    model: "model.ixs_fun=value.ixs_fun",
                                    serverFilters: serverFilters
                                }, false))
                }
                if (this.typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.Prideleni) {
                    Form
                        .addSection("jres:32000693") //RC 32000693 : Změna cíle redistribuce
                        .addRow("jres:32000685") //RC 32000685 : Spisový uzel
                    Form
                        .addField("gselectbox", Gordic.Gin.Fields.ginspodSSU(
                            {
                                name: "suField",
                                //model: "IxsSu = ixs_su",
                                model: "model.ixs_su=value.ixs_su",
                                serverFilters: {
                                    aktivita: [100],
                                },
                                states: [
                                    {
                                        icon: 'fa-info-circle',
                                        customClass: "g-state-info",
                                        tooltip: "jres:32000692" //RC 32000692 : Pro změnu cíle přidělení je potřeba vyplnit políčko.
                                    }
                                ],
                            }, true))
                    Form
                        .addRow("jres:32000694") //RC 32000694 : Funkční místo
                        .addField("gselectbox",
                            Gordic.Gin.Fields.ginsfunSSU(
                                {
                                    name: "funField",
                                    //model: "IxsFun = ixs_fun",
                                    model: "model.ixs_fun=value.ixs_fun",
                                    serverFilters: {
                                        aktivita: [100],
                                        VazbaNaSpisovyDenik: this.gcontent.EpkParams.ssl_pripreomez === 1,
                                        ixs_su: new Gordic.Forms.Dependency("suField", "ixs_su", false)
                                    },
                                }, true, "suField"))
                }
            }
            this.form.gform("createFrom", Form);
            return this.form;
        }

        private createCommandbar(): MenuParams[] {
            var commandBar: MenuParams[] = [];
            if (this.stateBezPripominek === true) {
                commandBar.push(this.addWithoutCommentAction());
            }
            commandBar.push(this.addContinueAction());
            commandBar.push(this.addCancelAction());
            return commandBar;
        }

        private addWithoutCommentAction() {

            var that = this;

            var action: MenuParams = {
                action: this.gcontent.actions.add(new GAction({
                    name: "actBezPripominek",
                    caption: "jres:32000679",		//RC 32000679 : Bez připomínek
                    tooltip: "jres:32000681", //RC 32000681 : Pokračovat bez připomínek
                    run: function (ev: any) {
                        var dto: any = { duvod_vyrizeni: "jres:32000680" }; //RC 32000680 : Bez připomínek
                        that.dfd.resolve(dto);
                        $.content(ev.currentTarget).close();
                    }
                }))
            }
            return action;
        }

        private addContinueAction(): MenuParams {
            var that = this;
            var continueAction: MenuParams = {
                primary: true,
                action: this.gcontent.actions.add(new GAction({
                    name: "actPokracovatVyrizeniEpk",
                    caption: "jres:32000138",		//RC 32000138 : Pokračovat
                    run: function(ev: any) {
                        var dto: any = {};
                        that.form.findFields().gfield("model", "collect", dto);
                        if (that.validateForm(that.form) === true) {
                           that.dfd.resolve(dto);
                           $.content(ev.currentTarget).close();
                        }
                    }
                }))
            }

            return continueAction;
        }

        private addCancelAction(): MenuParams {
            var that = this;
            var cancelAction: MenuParams = {
                action: this.gcontent.actions.add(new GAction({
                    name: "actZrusitVyrizeniEpk",
                    caption: "jres:32000024",		//RC 32000024 : Zrušit
                    run: function (ev: any, ctx){
                        that.dfd.reject({
                            reason: "",
                            handled: true,
                            type: EReasonType.userCancelled,
                            operation: OperationsEnum.sign
                        });
                        $.content(ev.currentTarget).close();
                    }
                }))
            }
            return cancelAction;
        }

        private validateForm(form: JQuery<HTMLElement>) {
            return form.gform("isValid");
        }

    }

    //#endregion

}